// Typed accessor over the LIGHT lane index (src/data/lanes-index.json, ~250KB) used by the React
// hub + for pre-fetch page titles. The FULL 6MB lanes.generated.json is NEVER imported here. The
// per-lane page fetches its own dist/data/lanes/<slug>.json (written by prerender.lanes.mjs) on mount.
// Keep functions/_middleware.js LANE_SLUGS in sync. It imports the same JSON.
import raw from './lanes-index.json'

// A row of the light index. The full lane object (carrier_rows, next_departures, coords, reliability)
// is defined in LanePage.tsx, which owns the fetched shape.
export interface Lane {
  slug: string
  trade: string
  o: string
  d: string
  o_name: string
  d_name: string
  o_cc: string
  d_cc: string
  sailings: number
  carriers: number
  median_transit: number
  has_reliability: boolean
}

export const LANES = raw as Lane[]

export const laneBySlug = (slug: string): Lane | undefined => LANES.find((l) => l.slug === slug)
